import { StatusChipProps } from "./types";
import { colors } from "../../../../../styles/variables";
import { Chip } from "@mui/material";

export const StatusChip = (props: StatusChipProps) => {
  const status = props?.isActive ? "Active" : "Not Active";
  const color = props?.isActive ? colors.green : colors.red;
  const textColor = props?.isActive ? colors.black : colors.gray2;
  return (
    <Chip
      label={status}
      variant="outlined"
      style={{ 
        backgroundColor: `${color}`, 
        color: `${textColor}`,
        pointerEvents: 'none'
      }}
    />
  );
};
